import types from './types';

export function openGameEdit(id) {
    return {
        type: types.OPEN_GAME_EDIT,
        payload: {
            id
        }
    };
}

export function openGamesList() {
    return {
        type: types.OPEN_GAMES_LIST,

    };
}



// WEBPACK FOOTER //
// ./src/js/actions/flow-actions.jsx